import React from "react";

function SvgIcMapPoi042(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M10.448 20l-.118 1.021A1.993 1.993 0 0112.121 23h7.75c0-1.035.79-1.877 1.796-1.98l-.17-1.02h1.006L23 24H9l.442-4h1.006zm.538-10l-.656 6.02c.952.1 1.707.86 1.784 1.818l.007.162h7.75c0-.981.708-1.787 1.64-1.957l.157-.023-.66-6.02h1.006L23 19H9l.98-9h1.006zM19 10l-.006.123c-.102.978-1.403 1.75-2.994 1.75-1.59 0-2.892-.772-2.994-1.75L13 10h6zm5.5-2a.5.5 0 01.492.41L25 8.5v2a.5.5 0 01-.41.492L24.5 11h-1.306L23 10h1V9H8v1h1l-.15 1H7.5a.5.5 0 01-.492-.41L7 10.5v-2a.5.5 0 01.41-.492L7.5 8h17z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi042;
